import styled from 'styled-components';
import theme from 'src/theme';

export interface IInputProps {
    isNotValid?: boolean;
}

export const IntegerErrorWrapper = styled.div`
    display: flex;
    align-content: right;
    justify-content: right;
    justify-content: flex-end;
    color: ${theme.legacyColors.error};
    font-size: 0.9rem;
    font-weight: 500;
    text-align: right;
    margin-top: 5px;
`;

export const IntegerInputWrapper = styled.div<IInputProps>`
    display: flex;
    justify-content: right;
    font-size: 0.8rem;
    height: max-content;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;

export const IntegerInputOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
